'use client'

import dynamic from 'next/dynamic'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material'
import { CancelTwoTone as CancelTwoToneIcon, CheckCircleTwoTone as CheckCircleTwoToneIcon } from '@mui/icons-material'

// Types
import type { DialogProps } from '@/types/components/molecules/dialog'

//Components
const LoadingButtonAtom = dynamic(() => import('@/components/atoms/button/loading'))
const OutlinedButtonAtom = dynamic(() => import('@/components/atoms/button/outlined'))

const DialogMolecule = (props: DialogProps) => {
	// Props
	const { type, title, description, confirm, close, loading, open, fullScreen, setOpen, confirmAction, children } = props

	return (
		<Dialog
			open={open}
			fullScreen={fullScreen === true}
			onClose={() => setOpen(false)}
			component={type === 'form' ? 'form' : undefined}
			slotProps={{
				paper: {
					...(type === 'form' && {
						component: 'form',
						encType: 'multipart/form-data'
					}),
					...(fullScreen === false && {
						sx: {
							width: '90dvw',
							maxWidth: '90dvw'
						}
					})
				}
			}}
		>
			{title && <DialogTitle>{title}</DialogTitle>}

			{(description || children) && (
				<DialogContent sx={{ pb: 1 }}>
					{description && <DialogContentText>{description}</DialogContentText>}
					{children}
				</DialogContent>
			)}

			<DialogActions>
				{close && <OutlinedButtonAtom text={close} size="small" color="error" startIcon={<CancelTwoToneIcon />} onClick={() => setOpen(false)} />}

				{confirm && (
					<LoadingButtonAtom
						type={type === 'form' ? 'submit' : undefined}
						text={confirm}
						size="small"
						color="success"
						loading={loading}
						startIcon={<CheckCircleTwoToneIcon />}
						onClick={confirmAction}
					/>
				)}
			</DialogActions>
		</Dialog>
	)
}

export default DialogMolecule
